import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgChatBubbleIconSecondary from './svgs/ChatBubbleIconSecondary.js';
import SvgChatBubbleIcon from './svgs/ChatBubbleIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var chatBubbleIcon = (props => useIcon(SvgChatBubbleIcon, SvgChatBubbleIconSecondary, props));

export { chatBubbleIcon as default };
